import { render } from "./ListOfSuras.vue?vue&type=template&id=3ad29f0d&ts=true"
import script from "./ListOfSuras.vue?vue&type=script&lang=ts"
export * from "./ListOfSuras.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__